<template>
  <div>
    <vue2Dropzone
      ref="myVueDropzone"
      id="hiddenDropzone"
      v-on:vdropzone-success="fileUploaded"
      v-on:vdropzone-file-added="fileAdded"
      :awss3="awss3"
      :destroyDropzone="false"
      :options="dropzoneOptions"
    ></vue2Dropzone>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'app',
  components: {
    vue2Dropzone
  },
  watch: {
    value: function(val) {
      let self = this
      if (self.newFiles.length == 0 && val.length > 0) {
        val.forEach(function(f) {
          let file = {
            size: f.size,
            name: f.name,
            type: f.name,
            s3ObjectLocation: f.s3ObjectLocation
          }
          let url = f.s3ObjectLocation
          self.$refs.myVueDropzone.manuallyAddFile(file, url)
        })
      }
      this.newFiles = val
    }
  },
  data: function() {
    return {
      newFiles: [],
      awss3: {
        signingURL: f => {
          return (
            'https://phi87a8msl.execute-api.eu-west-1.amazonaws.com/default/Ecobanka-S3PresignedUpload?fileName=' +
            f.name
          )
        },
        headers: {},
        sendFileToServer: true,
        withCredentials: false
      },
      dropzoneOptions: {
        url: 'https://webhook.site/29109250-2f84-4c57-b8d1-02910b565576',
        method: 'put',
        thumbnailWidth: 150,
        maxFilesize: 5,
        addRemoveLinks: true,
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json',
          'Cache-Control': null,
          'X-Requested-With': null
        }
      }
    }
  },
  computed: {},
  mounted() {},
  methods: {
    fileUploaded: function(file) {
      this.$emit('fileAdded', file)
    },
    fileAdded: function() {
      this.$emit('newFile')
    }
  }
}
</script>

<style scoped>
#hiddenDropzone {
  display: none;
}
</style>
<style lang="scss"></style>
